import { create } from "zustand";
import {
  WorkflowContainerCheckPointI,
  WorkflowContainerCheckPointActionI,
} from "../../../libs/interfaces";
import { persist } from "zustand/middleware";
import { createWorkflowCheckpointSlice } from "./workflow-checkpoint.store";
// import { unifiedZustandStorage } from '../../../libs/helpers';
// const storage = unifiedZustandStorage;

export const useWorkflowCheckpointStore = create<
  WorkflowContainerCheckPointI & WorkflowContainerCheckPointActionI
>()(
  persist(
    (...a) => ({
      ...createWorkflowCheckpointSlice(...a),
    }),
    {
      name: "workflow-container-checkpoint-puce-3",
      // storage: createJSONStorage(() => storage),
    }
  )
);
